import { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import styled from '@emotion/styled';
import { Text, tokens, Button } from '@hotjar/hotsauce';
import { useTrack } from '@hotjar/webapp/hooks/useTrack';
import { EmailTrackingCodeMobile } from '../EmailTrackingCode';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 0 auto;
`;

const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  text-align: left;
  padding: 0 ${tokens.spacer.x2};
  max-width: 480px;
  flex-grow: 1;
  justify-content: center;
`;

const SkipButton = styled(Button)`
  padding-bottom: ${tokens.spacer.x2pt5};
  margin: 0 auto;
`;

const OptionalText = styled.span`
  ${tokens.text('header5')};
`;

interface MobileOnlyStepProps {
  onSkip: () => void;
}

export const MobileOnlyStep = ({ onSkip }: MobileOnlyStepProps): JSX.Element => {
  const [instructionsShared, setInstructionsShared] = useState(false);
  const { t } = useTranslation();
  const { click: trackClick } = useTrack();

  const handleOnSkip = () => {
    trackClick('Skip mobile step', 'Mobile Onboarding Step', {});
    onSkip();
  };

  return (
    <Wrapper data-testid="mobile-setup-step">
      <Content>
        <Text
          style={{ marginBottom: tokens.spacer.x2pt5, whiteSpace: 'unset' }}
          as="h1"
          textType="header4"
        >
          <Trans i18nKey="activation:mobile-onboarding.step.title">
            Share installation instructions <OptionalText>(optional)</OptionalText>
          </Trans>
        </Text>
        <Text style={{ marginBottom: tokens.spacer.x3 }} as="p" textType="body1">
          {t('activation:mobile-onboarding.step.description')}
        </Text>
        <EmailTrackingCodeMobile onSuccess={() => setInstructionsShared(true)} />
      </Content>
      {!instructionsShared ? (
        <SkipButton onClick={handleOnSkip} kind="ghost">
          {t('activation:mobile-onboarding.step.skip')}
        </SkipButton>
      ) : null}
    </Wrapper>
  );
};
